"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var tslib_1 = require("tslib");
var mathjs_1 = require("mathjs");
var comparator = tslib_1.__importStar(require("./comparator"));
var preparse_1 = require("./preparse");
function create(imports) {
    return function expression() {
        var expression = mathjs_1.create(tslib_1.__assign(tslib_1.__assign({}, mathjs_1.all), comparator), { matrix: 'Array' });
        expression.import(imports, {});
        var evaluate = expression.evaluate.bind(expression);
        expression.evaluate = function (expr, scope) {
            var expression = typeof expr === 'string' ? preparse_1.preparse(expr) : expr;
            return scope ? evaluate(expression, scope) : evaluate(expression);
        };
        return expression;
    };
}
exports.create = create;
//# sourceMappingURL=factory.js.map